import angular from 'angular';
import Popup from '../../../../common/services/popup';
import templateUrl from './scheduling-popup.modal.ngtemplate.html';
import schedulingWidget from './scheduling-widget/scheduling-widget';
class SchedulingPopup extends Popup {
    constructor($rootScope, $modal) {
        super();
        this.$rootScope = $rootScope;
        this.$modal = $modal;
        this.templateUrl = '';
        this.contentTemplateUrl = templateUrl;
        this.backdrop = true;
    }
    open(data) {
        super.open(data);
    }
}
export default angular
    .module('doxy.common.services.schedulingPopup', [schedulingWidget])
    .service('schedulingPopup', SchedulingPopup).name;
